import { getSnippetData } from "../../api/apiCall"
import BaseModal from "../layout/BaseModal"
import { useQuery } from "@tanstack/react-query"
import { useAccessibility } from "../../context/AccessibilityContext"
import BaseHeadline from "./BaseHeadline"
import { useContext } from "react"
import { ThemeContext } from "../../context/ThemeContext"
import { ReactComponent as DOCUMENT } from "../../assets/Document.svg"
import BaseSubheadline from "./BaseSubheadline"
import { API } from "../../constants/constants"

export default function FoodModal() {
    // Snippets Laden
    const { easySpeech } = useAccessibility()
    const themeColors = useContext(ThemeContext)
    const { data: foodCardContent } = useQuery({
        queryKey: ["snippet-foodCard" + (easySpeech ? "/simple" : "/de")],
        queryFn: () => getSnippetData({ lang: easySpeech ? "/simple" : "/de", snippet: "menu" }),
    })

    return (
        <BaseModal modalId={2} small>
            <BaseHeadline
                headlineType={4}
                classProps="mt-8 md:mt-0 break-words"
                label={"Speisekarte"}
                customColor={themeColors?.color?.bg2 === themeColors?.color?.text ? "bg-neutral" : themeColors?.color?.text}
            />
            {foodCardContent?.content?.menuBlock?.map((item: any, index: number) => (
                <div
                    key={index}
                    onClick={() => {
                        window.open(API + item.menuFile?.url, "_blank")
                    }}
                    className="flex items-center gap-4 border-dashed rounded-default p-4 border-primary border-2 mt-4 cursor-pointer hover:bg-white hover:border-separate duration-300 transition-all">
                    <DOCUMENT className="w-8 h-8 text-black" />
                    <BaseSubheadline label={item.menuTitle} customColor={"black"} />
                </div>
            ))}
        </BaseModal>
    )
}
